'use client'

import { useState, useEffect, useContext } from 'react'
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  TransitionChild,
} from '@headlessui/react'
import {
  Bars3Icon,
  BellIcon,
  CalendarIcon,
  ChartPieIcon,
  Cog6ToothIcon,
  DocumentDuplicateIcon,
  FolderIcon,
  UserIcon,
  HomeIcon,
  CogIcon,
  ChartBarIcon,
  DocumentTextIcon,
  PencilIcon,
  ExclamationTriangleIcon,
  UserGroupIcon,
  ClipboardDocumentListIcon,
  CpuChipIcon,
  ChatBubbleLeftRightIcon,
  ClockIcon,
  MapPinIcon,
  CalendarDaysIcon,
  SunIcon,
  CurrencyPoundIcon,
  UsersIcon,
  XMarkIcon,
  UserCircleIcon,
  VideoCameraIcon,
  EyeIcon,
  HandRaisedIcon,
  QuestionMarkCircleIcon,
  AcademicCapIcon,
  UserPlusIcon,
  BookOpenIcon,
  LightBulbIcon,
} from '@heroicons/react/24/outline'
import { CalendarDateRangeIcon, ChatBubbleLeftEllipsisIcon, ChevronDownIcon, MagnifyingGlassIcon } from '@heroicons/react/20/solid'
import ActivityFeedHelp from './ActivityFeedHelp'
import { AuthContext } from '../AuthContext';
import AdminDashboardHelp from './AdminDashboardHelp'
import OnboardingHomeHelp from './OnboardingHomeHelp'
import CompanyInformationHelp from './CompanyInformationHelp'
import RoleCalibrationHelp from './RoleCalibrationHelp'
import PoliciesHelp from './PoliciesHelp'
import UserManagementHelp from './UserManagementHelp'
import MembersHelp from './MembersHelp'
import StaffCostsHelp from './StaffCostsHelp'
import ProcessCreatorHelp from './ProcessCreatorHelp'
import StatsHelp from './StatsHelp'
import StaffDetailsHelp from './StaffDetailsHelp'
import ReportingHelp from './ReportingHelp'
import AppraisalFormHelp from './AppraisalFormHelp'
import EditAppraisalHelp from './EditAppraisalHelp'
import DisciplinaryFormHelp from './DisciplinaryFormHelp'
import HRHelp from './HRHelp'
import BackToWorkDashboardHelp from './BackToWorkDashboardHelp'
import BackToWorkFormHelp from './BackToWorkFormHelp'
import SicknessAIHelp from './SicknessAIHelp'
import SicknessReportHelp from './SicknessReportHelp'
import AnalyticsHelp from './AnalyticsHelp'
import OvertimeManagerHelp from './OvertimeManagerHelp';
import TravelHelp from './TravelHelp';
import ClockInHelp from './ClockInHelp';
import BookShiftsHelp from './BookShiftsHelp';
import HolidayChartHelp from './HolidayChartHelp'
import HolidayBookHelp from './HolidayBookHelp';
import MeetingsHelp from './MeetingsHelp';
import CommunicationsHelp from './CommunicationsHelp'
import MyProfileHelp from './MyProfileHelp';
import TaskCalendarHelp from './TaskCalendarHelp'
import TaskCalendarTodayHelp from './TaskCalendarTodayHelp'
import TaskCalendarTeamHelp from './TaskCalendarTeamHelp'
import BottlenecksHelp from './BottlenecksHelp'
import NewsHomeHelp from './NewsHomeHelp'
import CreateProjectHelp from './CreateProjectHelp'
import KanbanHelp from './KanbanHelp'
import ProjectMeetingHelp from './ProjectMeetingHelp'
import ProjectChatHelp from './ProjectChatHelp'
import ProjectDailyTasksHelp from './ProjectDailyTasksHelp'

import TaskTrainingHelp from './TaskTrainingHelp'
import RecruitmentHelp from './RecruitmentHelp'
import PDFScannerHelp from './PDFScannerHelp'
import InterviewMeetingHelp from './InterviewMeetingHelp'
import CurrentTaskHelp from './CurrentTaskHelp'
import DocumentBuilderHelp from './DocumentBuilderHelp'
import QuizBuilderHelp from './QuizBuilderHelp'
import KnowledgeTreeHelp from './KnowledgeTreeHelp'
import TrainingStatsHelp from './TrainingStatsHelp'
import VisitorsHelp from './VisitorsHelp'
import LoginsHelp from './LoginsHelp'
import AIAssistantHelp from './AIAssistantHelp'
import BillingHelp from './BillingHelp'
import OnlineHelp from './OnlineHelp'
import OrganizationTreeHelp from './OrganizationTreeHelp'
import AIAssistant from '../manager/aiassistant'
import TrainingBook from '../manager/trainingbook'
import CustomerCrmHelp from './CustomerCrmHelp'
import AvenorGuideHelp from './AvenorGuideHelp'
import AvenorDocs from './AvenorDocs'
import BrainstormHelp from './BrainstormHelp'




const navigation = [
  { name: 'Onboarding', href: '#onboarding', icon: HomeIcon, current: true, group: 'onboarding' },
  { name: 'Company Info', href: '#company-info', icon: UsersIcon, current: false, group: 'onboarding' },
  { name: 'Role Calibration', href: '#role-calibration', icon: FolderIcon, current: false, group: 'onboarding' },
  { name: 'Policies', href: '#policies', icon: Cog6ToothIcon, current: false, group: 'onboarding' },
  { name: 'User Management', href: '#user-management', icon: UserCircleIcon, current: false, group: 'onboarding' },
  { name: 'Create Teams', href: '#members', icon: UsersIcon, current: false, group: 'onboarding' },
  { name: 'Staff Costs', href: '#staff-costs', icon: CurrencyPoundIcon, current: false, group: 'onboarding' },
  { name: 'Process Creator', href: '#process-creator', icon: CogIcon, current: false, group: 'onboarding' },
  { name: 'Admin Dashboard', href: '#admin-dashboard', icon: CalendarIcon, current: false, group: 'ui' },
  { name: 'Activity Feed', href: '#activity-feed', icon: DocumentDuplicateIcon, current: false, group: 'ui' },
  { name: 'Stats', href: '#stats', icon: ChartBarIcon, current: false, group: 'ui' },
  { name: 'Records', href: '#staff-details', icon: UsersIcon, current: false, group: 'management' },
  { name: 'Reporting', href: '#reporting', icon: ChartPieIcon, current: false, group: 'management' },
  { name: 'Appraisal Forms', href: '#appraisal-forms', icon: DocumentDuplicateIcon, current: false, group: 'management' },
  { name: 'Edit Appraisal', href: '#edit-appraisal', icon: PencilIcon, current: false, group: 'management' },
  { name: 'Disciplinary Form', href: '#disciplinary-form', icon: ExclamationTriangleIcon, current: false, group: 'management' },
  { name: 'HR', href: '#hr', icon: UserGroupIcon, current: false, group: 'management' },
  { name: 'Back-to-Work Dashboard', href: '#back-to-work-dashboard', icon: ClipboardDocumentListIcon, current: false, group: 'management' },
  { name: 'Back-to-Work Form', href: '#back-to-work-form', icon: DocumentTextIcon, current: false, group: 'management' },
  { name: 'Sickness AI', href: '#sickness-ai', icon: CpuChipIcon, current: false, group: 'management' },
  { name: 'Sickness Report', href: '#sickness-report', icon: ChatBubbleLeftRightIcon, current: false, group: 'management' },
  { name: 'Analytics', href: '#analytics', icon: ChartBarIcon, current: false, group: 'management' },
  { name: 'Overtime Manager', href: '#overtime-manager', icon: ClockIcon, current: false, group: 'management' },
  { name: 'Travel', href: '#travel', icon: MapPinIcon, current: false, group: 'management' },
  { name: 'Clock In', href: '#clock-in', icon: ClockIcon, current: false, group: 'management' },
  { name: 'Book Shifts', href: '#book-shifts', icon: CalendarDaysIcon, current: false, group: 'management' },
  { name: 'Holiday Chart', href: '#holiday-chart', icon: ChartBarIcon, current: false, group: 'management' },
  { name: 'Holiday Booking', href: '#holiday-booking', icon: SunIcon, current: false, group: 'management' },
  { name: 'Meetings', href: '#meetings', icon: VideoCameraIcon, current: false, group: 'management' },
  { name: 'Admin Tasks', href: '#admin-tasks', icon: ClipboardDocumentListIcon, current: false, group: 'management' },
  { name: 'Chat', href: '#communications', icon: ChatBubbleLeftEllipsisIcon, current: false, group: 'general' },
  { name: 'My Profile', href: '#my-profile', icon: UserCircleIcon, current: false, group: 'general' },
  { name: 'Visitor Management', href: '#visitor-management', icon: UserCircleIcon, current: false, group: 'general' },
  { name: 'User Sessions', href: '#user-sessions', icon: UserGroupIcon, current: false, group: 'general' },
  { name: 'AI Assistant', href: '#ai-assistant', icon: CpuChipIcon, current: false, group: 'general' },
  { name: 'Billing', href: '#billing', icon: CurrencyPoundIcon, current: false, group: 'general' },
  { name: 'Staff Online', href: '#staff-online', icon: UserGroupIcon, current: false, group: 'general' },
  { name: 'Organization Tree', href: '#organization-tree', icon: UserPlusIcon, current: false, group: 'general' },
  { name: 'New Feed', href: '#news-feed', icon: UsersIcon, current: false, group: 'general' },
  { name: 'Task Calendar', href: '#task-calendar', icon: CalendarDaysIcon, current: false, group: 'tasks' },
  { name: 'Daily Task Timeline', href: '#daily-task-timeline', icon: ClockIcon, current: false, group: 'tasks' },
  { name: 'Team Task Calendar', href: '#team-task-calendar', icon: UserGroupIcon, current: false, group: 'tasks' },
  { name: 'Bottlenecks', href: '#bottlenecks', icon: ExclamationTriangleIcon, current: false, group: 'tasks' },
  { name: 'Bottleneck Analysis', href: '#bottleneck-analysis', icon: EyeIcon, current: false, group: 'tasks' },
  { name: 'Sales / Project CRM', href: '#customer-crm', icon: UsersIcon, current: false, group: 'general' },
  { name: 'Avenor Guide', href: '#avenor-guide', icon: CpuChipIcon, current: false, group: 'general' },
  { name: 'Avenor Docs', href: '#avenor-docs', icon: BookOpenIcon, current: false, group: 'general' },
  { name: 'Create Project', href: '#create-project', icon: FolderIcon, current: false, group: 'projects' },
  { name: 'Kanban Board', href: '#kanban-board', icon: ChartBarIcon, current: false, group: 'projects' },
  { name: 'Brainstorm', href: '#brainstorm', icon: LightBulbIcon, current: false, group: 'projects' },
  { name: 'Daily Tasks', href: '#project-daily-tasks', icon: ClockIcon, current: false, group: 'projects' },
  { name: 'Project Meetings', href: '#project-meetings', icon: VideoCameraIcon, current: false, group: 'projects' },
  { name: 'Project Chat', href: '#project-chat', icon: ChatBubbleLeftRightIcon, current: false, group: 'projects' },
  { name: 'CV Scanner', href: '#cv-scanner', icon: DocumentTextIcon, current: false, group: 'recruitment' },
  { name: 'Interview Meetings', href: '#interview-meetings', icon: VideoCameraIcon, current: false, group: 'recruitment' },
  { name: 'Document Builder', href: '#document-builder', icon: DocumentTextIcon, current: false, group: 'training' },
  { name: 'Quiz Builder', href: '#quiz-builder', icon: QuestionMarkCircleIcon, current: false, group: 'training' },
  { name: 'Training Stats', href: '#training-stats', icon: ChartBarIcon, current: false, group: 'training' },
  { name: 'Knowledge Tree', href: '#knowledge-tree', icon: AcademicCapIcon, current: false, group: 'training' },


]

const faq = [
  { id: 1, name: 'How to reset my password?', href: '#', initial: 'RP', current: false },
  { id: 2, name: 'How to add a new employee?', href: '#user-management', initial: 'AE', current: false },
  { id: 3, name: 'How to schedule a meeting?', href: '#meetings', initial: 'SM', current: false },
  { id: 4, name: 'How to view team performance?', href: '#staff-details', initial: 'VP', current: false },
  { id: 5, name: 'How to submit a leave request?', href: '#holiday-booking', initial: 'LR', current: false },
  { id: 6, name: 'How to access training materials?', href: '#', initial: 'TM', current: false },
  { id: 7, name: 'How to report an issue?', href: '#ai-assistant', initial: 'RI', current: false },
  { id: 8, name: 'How to update my profile?', href: '#user-management', initial: 'UP', current: false },
]
const userNavigation = [
  { name: 'Back to Dashboard', href: '/dashboard' },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Example() {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const [activeSection, setActiveSection] = useState('onboarding')
  const [AI, setAI] = useState(true)
  const [training, setTraining] = useState(false)

  const [isMobile, setIsMobile] = useState(false);

  const user = useContext(AuthContext);


  const handleCloseAIAssistant = () => {
    setAI(false); 
  };

  

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024); // Example breakpoint for mobile
    };

    window.addEventListener('resize', handleResize);

    handleResize(); // Initial check

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  
  // Intersection Observer for tracking active section
  useEffect(() => {
    const sections = ['onboarding', 'company-info', 'role-calibration', 'policies', 'user-management', 'members', 'staff-costs', 'process-creator', 'admin-dashboard', 'activity-feed', 'stats', 'staff-details', 'reporting', 'appraisal-forms', 'edit-appraisal', 'disciplinary-form', 'hr', 'back-to-work-dashboard', 'back-to-work-form', 'sickness-ai', 'sickness-report', 'analytics', 'overtime-manager', 'travel', 'clock-in', 'book-shifts', 'holiday-chart', 'holiday-booking', 'meetings', 'admin-tasks', 'communications', 'my-profile', 'visitor-management', 'user-sessions', 'ai-assistant', 'billing', 'staff-online', 'organization-tree', 'task-calendar', 'daily-task-timeline', 'team-task-calendar', 'bottlenecks', 'task-training', 'news-feed', 'create-project', 'kanban-board', 'project-daily-tasks', 'project-drag-drop', 'project-meetings', 'project-chat', 'recruitment-overview', 'cv-scanner', 'interview-meetings', 'document-builder', 'quiz-builder', 'training-stats', 'knowledge-tree', 'avenor-guide', 'avenor-docs']

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id)
          }
        })
      },
      {
        rootMargin: '-50% 0px -50% 0px',
        threshold: 0
      }
    )

    sections.forEach((section) => {
      const element = document.getElementById(section)
      if (element) {
        observer.observe(element)
      }
    })

    return () => observer.disconnect()
  }, [])

  const handleSearch = (e) => {
    e.preventDefault()
    const sections = ['onboarding', 'company-info', 'role-calibration', 'policies', 'user-management', 'members', 'staff-costs', 'process-creator', 'admin-dashboard', 'activity-feed', 'stats', 'staff-details', 'reporting', 'appraisal-forms', 'edit-appraisal', 'disciplinary-form', 'hr', 'back-to-work-dashboard', 'back-to-work-form', 'sickness-ai', 'sickness-report', 'analytics', 'overtime-manager', 'travel', 'clock-in', 'book-shifts', 'holiday-chart', 'holiday-booking', 'meetings', 'admin-tasks', 'communications', 'my-profile', 'visitor-management', 'user-sessions', 'ai-assistant', 'billing', 'staff-online', 'organization-tree', 'task-calendar', 'daily-task-timeline', 'team-task-calendar', 'bottlenecks', 'task-training', 'news-feed', 'create-project', 'kanban-board', 'project-daily-tasks', 'project-drag-drop', 'project-meetings', 'project-chat', 'recruitment-overview', 'cv-scanner', 'interview-meetings', 'document-builder', 'quiz-builder', 'training-stats', 'knowledge-tree', 'avenor-guide', 'avenor-docs']
    const matchingSection = sections.find(section => section.toLowerCase().includes(searchTerm.toLowerCase()))
    if (matchingSection) {
      document.getElementById(matchingSection).scrollIntoView({ behavior: 'smooth' })
    }
  }

  if (training) {
    return <TrainingBook onClose={() => setTraining(false)} />
  }


  return (
    <>
      {/*
        This example requires updating your template:

        ```
        <html class="h-full bg-white dark:bg-gray-900">
        <body class="h-full">
        ```
      */}
      <div>
        <Dialog open={sidebarOpen} onClose={setSidebarOpen} className="relative z-50 lg:hidden">
          <DialogBackdrop
            transition
            className="fixed inset-0 bg-gray-900/80 transition-opacity duration-300 ease-linear data-[closed]:opacity-0"
          />

          <div className="fixed inset-0 flex">
            <DialogPanel
              transition
              className="relative mr-16 flex w-full max-w-xs flex-1 transform transition duration-300 ease-in-out data-[closed]:-translate-x-full"
            >
              <TransitionChild>
                <div className="absolute left-full top-0 flex w-16 justify-center pt-5 duration-300 ease-in-out data-[closed]:opacity-0">
                  <button type="button" onClick={() => setSidebarOpen(false)} className="-m-2.5 p-2.5">
                    <span className="sr-only">Close sidebar</span>
                    <XMarkIcon aria-hidden="true" className="size-6 text-gray-900" />
                  </button>
                </div>
              </TransitionChild>

              {/* Sidebar component, swap this element with another sidebar if you like */}
              <div className="relative flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 pb-4 ring-1 ring-gray-200">
                <div className="relative flex h-16 shrink-0 items-center">
                  <img
                    alt="Your Company"
                    src="logo192.png"
                    className="h-12 w-auto"
                  />
                </div>
                <nav className="relative flex flex-1 flex-col">
                  <ul role="list" className="flex flex-1 flex-col gap-y-7">
                    <li>
                      <div className="text-xs/6 font-semibold text-indigo-600 uppercase tracking-wider">Onboarding</div>
                      <ul role="list" className="-mx-2 mt-2 space-y-1">
                        {navigation.filter(item => item.group === 'onboarding').map((item) => (
                        <li key={item.name}>
                          <a
                            href={item.href}
                            className={classNames(
                              item.href.substring(1) === activeSection
                                ? 'bg-indigo-600 text-white'
                                : 'text-gray-600 hover:bg-indigo-100 hover:text-indigo-600',
                              'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold',
                            )}
                            onClick={(e) => {
                              e.preventDefault()
                              const targetId = item.href.substring(1)
                              document.getElementById(targetId).scrollIntoView({ behavior: 'smooth' })
                              setSidebarOpen(false)
                            }}
                          >
                            <item.icon aria-hidden="true" className="size-6 shrink-0" />
                            {item.name}
                          </a>
                        </li>
                        ))}
                      </ul>
                    </li>
                    <li>
                      <div className="text-xs/6 font-semibold text-purple-600 uppercase tracking-wider">UI</div>
                      <ul role="list" className="-mx-2 mt-2 space-y-1">
                        {navigation.filter(item => item.group === 'ui').map((item) => (
                        <li key={item.name}>
                          <a
                            href={item.href}
                            className={classNames(
                              item.href.substring(1) === activeSection
                                ? 'bg-purple-600 text-white'
                                : 'text-gray-600 hover:bg-purple-100 hover:text-purple-600',
                              'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold',
                            )}
                            onClick={(e) => {
                              e.preventDefault()
                              const targetId = item.href.substring(1)
                              document.getElementById(targetId).scrollIntoView({ behavior: 'smooth' })
                              setSidebarOpen(false)
                            }}
                          >
                            <item.icon aria-hidden="true" className="size-6 shrink-0" />
                            {item.name}
                          </a>
                        </li>
                        ))}
                      </ul>
                    </li>
                    <li>
                      <div className="text-xs/6 font-semibold text-green-600 uppercase tracking-wider">Management</div>
                      <ul role="list" className="-mx-2 mt-2 space-y-1">
                        {navigation.filter(item => item.group === 'management').map((item) => (
                        <li key={item.name}>
                          <a
                            href={item.href}
                            className={classNames(
                              item.href.substring(1) === activeSection
                                ? 'bg-green-600 text-white'
                                : 'text-gray-600 hover:bg-green-100 hover:text-green-600',
                              'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold',
                            )}
                            onClick={(e) => {
                              e.preventDefault()
                              const targetId = item.href.substring(1)
                              document.getElementById(targetId).scrollIntoView({ behavior: 'smooth' })
                              setSidebarOpen(false)
                            }}
                          >
                            <item.icon aria-hidden="true" className="size-6 shrink-0" />
                            {item.name}
                          </a>
                        </li>
                        ))}
                      </ul>
                    </li>
                    <li>
                      <div className="text-xs/6 font-semibold text-blue-600 uppercase tracking-wider">Projects</div>
                      <ul role="list" className="-mx-2 mt-2 space-y-1">
                        {navigation.filter(item => item.group === 'projects').map((item) => (
                        <li key={item.name}>
                          <a
                            href={item.href}
                            className={classNames(
                              item.href.substring(1) === activeSection
                                ? 'bg-blue-600 text-white'
                                : 'text-gray-600 hover:bg-blue-100 hover:text-blue-600',
                              'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold',
                            )}
                            onClick={(e) => {
                              e.preventDefault()
                              const targetId = item.href.substring(1)
                              document.getElementById(targetId).scrollIntoView({ behavior: 'smooth' })
                              setSidebarOpen(false)
                            }}
                          >
                            <item.icon aria-hidden="true" className="size-6 shrink-0" />
                            {item.name}
                          </a>
                        </li>
                        ))}
                      </ul>
                    </li>
                    <li>
                      <div className="text-xs/6 font-semibold text-purple-600 uppercase tracking-wider">Recruitment</div>
                      <ul role="list" className="-mx-2 mt-2 space-y-1">
                        {navigation.filter(item => item.group === 'recruitment').map((item) => (
                        <li key={item.name}>
                          <a
                            href={item.href}
                            className={classNames(
                              item.href.substring(1) === activeSection
                                ? 'bg-purple-600 text-white'
                                : 'text-gray-600 hover:bg-purple-100 hover:text-purple-600',
                              'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold',
                            )}
                            onClick={(e) => {
                              e.preventDefault()
                              const targetId = item.href.substring(1)
                              document.getElementById(targetId).scrollIntoView({ behavior: 'smooth' })
                              setSidebarOpen(false)
                            }}
                          >
                            <item.icon aria-hidden="true" className="size-6 shrink-0" />
                            {item.name}
                          </a>
                        </li>
                        ))}
                      </ul>
                    </li>
                    <li>
                      <div className="text-xs/6 font-semibold text-orange-600 uppercase tracking-wider">Training</div>
                      <ul role="list" className="-mx-2 mt-2 space-y-1">
                        {navigation.filter(item => item.group === 'training').map((item) => (
                        <li key={item.name}>
                          <a
                            href={item.href}
                            className={classNames(
                              item.href.substring(1) === activeSection
                                ? 'bg-orange-600 text-white'
                                : 'text-gray-600 hover:bg-orange-100 hover:text-orange-600',
                              'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold',
                            )}
                            onClick={(e) => {
                              e.preventDefault()
                              const targetId = item.href.substring(1)
                              document.getElementById(targetId).scrollIntoView({ behavior: 'smooth' })
                              setSidebarOpen(false)
                            }}
                          >
                            <item.icon aria-hidden="true" className="size-6 shrink-0" />
                            {item.name}
                          </a>
                        </li>
                        ))}
                      </ul>
                    </li>
                    <li>
                      <div className="text-xs/6 font-semibold text-cyan-600 uppercase tracking-wider">General</div>
                      <ul role="list" className="-mx-2 mt-2 space-y-1">
                        {navigation.filter(item => item.group === 'general').map((item) => (
                        <li key={item.name}>
                          <a
                            href={item.href}
                            className={classNames(
                              item.href.substring(1) === activeSection
                                ? 'bg-cyan-600 text-white'
                                : 'text-gray-600 hover:bg-cyan-100 hover:text-cyan-600',
                              'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold',
                            )}
                            onClick={(e) => {
                              e.preventDefault()
                              const targetId = item.href.substring(1)
                              document.getElementById(targetId).scrollIntoView({ behavior: 'smooth' })
                              setSidebarOpen(false)
                            }}
                          >
                            <item.icon aria-hidden="true" className="size-6 shrink-0" />
                            {item.name}
                          </a>
                        </li>
                        ))}
                      </ul>
                    </li>
                    <li>
                      <ul role="list" className="-mx-2 mt-2 space-y-1">
                        {faq.map((item) => (
                          <li key={item.name}>
                            <a
                              href={item.href}
                            className={classNames(
                              item.current
                                ? 'bg-indigo-600 text-white'
                                : 'text-gray-600 hover:bg-indigo-100 hover:text-indigo-600',
                              'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold',
                            )}
                            >
                            <span className="flex size-6 shrink-0 items-center justify-center rounded-lg border border-gray-200 bg-gray-50 text-[0.625rem] font-medium text-gray-600 group-hover:border-indigo-300 group-hover:text-indigo-600">
                              {faq.initial}
                            </span>
                              <span className="truncate">{faq.name}</span>
                            </a>
                          </li>
                        ))}
                      </ul>
                    </li>
                    
                  </ul>
                </nav>
              </div>
            </DialogPanel>
          </div>
        </Dialog>

        {/* Static sidebar for desktop */}
        <div className="hidden bg-white ring-1 ring-gray-200 lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-72 lg:flex-col">
          {/* Sidebar component, swap this element with another sidebar if you like */}
          <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 pb-4">
            <div className="flex h-16 shrink-0 items-center">
              <img
                alt="Your Company"
                src="1.png"
                className="h-24 w-auto rounded-full"
              />
            </div>
            <nav className="flex flex-1 flex-col">
              <ul role="list" className="flex flex-1 flex-col gap-y-7">
                <li>
                  <div className="text-xs/6 font-semibold text-indigo-600 uppercase tracking-wider">Onboarding</div>
                  <ul role="list" className="-mx-2 mt-2 space-y-1">
                    {navigation.filter(item => item.group === 'onboarding').map((item) => (
                        <li key={item.name}>
                          <a
                            href={item.href}
                            className={classNames(
                              item.href.substring(1) === activeSection ? 'bg-indigo-600 text-white' : 'text-gray-600 hover:bg-indigo-100 hover:text-indigo-600',
                              'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold',
                            )}
                            onClick={(e) => {
                              e.preventDefault()
                              const targetId = item.href.substring(1)
                              document.getElementById(targetId).scrollIntoView({ behavior: 'smooth' })
                            }}
                          >
                            <item.icon aria-hidden="true" className="size-6 shrink-0" />
                            {item.name}
                          </a>
                        </li>
                    ))}
                  </ul>
                </li>
                <li>
                  <div className="text-xs/6 font-semibold text-purple-600 uppercase tracking-wider">UI</div>
                  <ul role="list" className="-mx-2 mt-2 space-y-1">
                    {navigation.filter(item => item.group === 'ui').map((item) => (
                        <li key={item.name}>
                          <a
                            href={item.href}
                            className={classNames(
                              item.href.substring(1) === activeSection ? 'bg-purple-600 text-white' : 'text-gray-600 hover:bg-purple-100 hover:text-purple-600',
                              'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold',
                            )}
                            onClick={(e) => {
                              e.preventDefault()
                              const targetId = item.href.substring(1)
                              document.getElementById(targetId).scrollIntoView({ behavior: 'smooth' })
                            }}
                          >
                            <item.icon aria-hidden="true" className="size-6 shrink-0" />
                            {item.name}
                          </a>
                        </li>
                        
                    ))}
                  </ul>
                  
                </li>
                <li>
                  <div className="text-xs/6 font-semibold text-green-600 uppercase tracking-wider">Management</div>
                  <ul role="list" className="-mx-2 mt-2 space-y-1">
                    {navigation.filter(item => item.group === 'management').map((item) => (
                        <li key={item.name}>
                          <a
                            href={item.href}
                            className={classNames(
                              item.href.substring(1) === activeSection ? 'bg-green-600 text-white' : 'text-gray-600 hover:bg-green-100 hover:text-green-600',
                              'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold',
                            )}
                            onClick={(e) => {
                              e.preventDefault()
                              const targetId = item.href.substring(1)
                              document.getElementById(targetId).scrollIntoView({ behavior: 'smooth' })
                            }}
                          >
                            <item.icon aria-hidden="true" className="size-6 shrink-0" />
                            {item.name}
                          </a>
                        </li>
                        
                    ))}
                  </ul>
                  
                </li>
                <li>
                  <div className="text-xs/6 font-semibold text-blue-600 uppercase tracking-wider">Projects</div>
                  <ul role="list" className="-mx-2 mt-2 space-y-1">
                    {navigation.filter(item => item.group === 'projects').map((item) => (
                        <li key={item.name}>
                          <a
                            href={item.href}
                            className={classNames(
                              item.href.substring(1) === activeSection ? 'bg-blue-600 text-white' : 'text-gray-600 hover:bg-blue-100 hover:text-blue-600',
                              'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold',
                            )}
                            onClick={(e) => {
                              e.preventDefault()
                              const targetId = item.href.substring(1)
                              document.getElementById(targetId).scrollIntoView({ behavior: 'smooth' })
                            }}
                          >
                            <item.icon aria-hidden="true" className="size-6 shrink-0" />
                            {item.name}
                          </a>
                        </li>
                        
                    ))}
                  </ul>
                  
                </li>
                <li>
                  <div className="text-xs/6 font-semibold text-purple-600 uppercase tracking-wider">Recruitment</div>
                  <ul role="list" className="-mx-2 mt-2 space-y-1">
                    {navigation.filter(item => item.group === 'recruitment').map((item) => (
                        <li key={item.name}>
                          <a
                            href={item.href}
                            className={classNames(
                              item.href.substring(1) === activeSection ? 'bg-purple-600 text-white' : 'text-gray-600 hover:bg-purple-100 hover:text-purple-600',
                              'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold',
                            )}
                            onClick={(e) => {
                              e.preventDefault()
                              const targetId = item.href.substring(1)
                              document.getElementById(targetId).scrollIntoView({ behavior: 'smooth' })
                            }}
                          >
                            <item.icon aria-hidden="true" className="size-6 shrink-0" />
                            {item.name}
                          </a>
                        </li>
                        
                    ))}
                  </ul>
                  
                </li>
                <li>
                  <div className="text-xs/6 font-semibold text-orange-600 uppercase tracking-wider">Training</div>
                  <ul role="list" className="-mx-2 mt-2 space-y-1">
                    {navigation.filter(item => item.group === 'training').map((item) => (
                        <li key={item.name}>
                          <a
                            href={item.href}
                            className={classNames(
                              item.href.substring(1) === activeSection ? 'bg-orange-600 text-white' : 'text-gray-600 hover:bg-orange-100 hover:text-orange-600',
                              'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold',
                            )}
                            onClick={(e) => {
                              e.preventDefault()
                              const targetId = item.href.substring(1)
                              document.getElementById(targetId).scrollIntoView({ behavior: 'smooth' })
                            }}
                          >
                            <item.icon aria-hidden="true" className="size-6 shrink-0" />
                            {item.name}
                          </a>
                        </li>
                        
                    ))}
                  </ul>
                  
                </li>
                <li>
                  <div className="text-xs/6 font-semibold text-cyan-600 uppercase tracking-wider">General</div>
                  <ul role="list" className="-mx-2 mt-2 space-y-1">
                    {navigation.filter(item => item.group === 'general').map((item) => (
                        <li key={item.name}>
                          <a
                            href={item.href}
                            className={classNames(
                              item.href.substring(1) === activeSection ? 'bg-cyan-600 text-white' : 'text-gray-600 hover:bg-cyan-100 hover:text-cyan-600',
                              'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold',
                            )}
                            onClick={(e) => {
                              e.preventDefault()
                              const targetId = item.href.substring(1)
                              document.getElementById(targetId).scrollIntoView({ behavior: 'smooth' })
                            }}
                          >
                            <item.icon aria-hidden="true" className="size-6 shrink-0" />
                            {item.name}
                          </a>
                        </li>
                        
                    ))}
                  </ul>
                  
                </li>
                <li>
                  <ul role="list" className="-mx-2 mt-2 space-y-1">
                    {faq.map((team) => (
                      <li key={team.name}>
                        <a
                          href={team.href}
                            className={classNames(
                              team.current ? 'bg-indigo-600 text-white' : 'text-gray-600 hover:bg-indigo-100 hover:text-indigo-600',
                              'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold',
                            )}
                        >
                          <span className="flex size-6 shrink-0 items-center justify-center rounded-lg border border-gray-200 bg-gray-50 text-[0.625rem] font-medium text-gray-600 group-hover:border-indigo-300 group-hover:text-indigo-600">
                            {team.initial}
                          </span>
                          <span className="truncate">{team.name}</span>
                        </a>
                      </li>
                    ))}
                  </ul>
                </li>
                <li className="mt-auto">
                  <a
                    href="#"
                    className="group -mx-2 flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold text-gray-400 hover:bg-indigo-100 hover:text-indigo-600"
                  >
                    <Cog6ToothIcon aria-hidden="true" className="size-6 shrink-0" />
                    Settings
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>

        <div className="lg:pl-72">
          <div className="sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8">
            <button
              type="button"
              onClick={() => setSidebarOpen(true)}
              className="-m-2.5 p-2.5 text-gray-700 hover:text-gray-900 lg:hidden"
            >
              <span className="sr-only">Open sidebar</span>
              <Bars3Icon aria-hidden="true" className="size-6" />
            </button>

            {/* Separator */}
            <div aria-hidden="true" className="h-6 w-px bg-gray-900/10 lg:hidden" />

            <div className="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
              <form action="#" method="GET" className="grid flex-1 grid-cols-1" onSubmit={handleSearch}>
                <input
                  name="search"
                  placeholder="Search documentation..."
                  aria-label="Search"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="col-start-1 row-start-1 block size-full bg-white pl-8 text-base text-gray-900 outline-none placeholder:text-gray-400 sm:text-sm/6"
                />
                <MagnifyingGlassIcon
                  aria-hidden="true"
                  className="pointer-events-none col-start-1 row-start-1 size-5 self-center text-gray-400"
                />
              </form>
              <div className="flex items-center gap-x-4 lg:gap-x-6">
                <button
                  onClick= {() => setAI(true)}
                  className="-m-2.5 p-2.5 text-emerald-500 animate-bounce hover:text-gray-500"
                >
                  <span className="sr-only">View notifications</span>
                  <ChatBubbleLeftEllipsisIcon aria-hidden="true" className="size-6 " />
                </button>
                               {(user.Access === 'admin' || user.Access === 'manager') && (
                  <button
                    onClick={() => setTraining(true)}
                    className="-m-2.5 p-2.5 text-emerald-500 animate-bounce hover:text-gray-500"
                  >
                    <span className="sr-only">Book Training</span>
                    <CalendarDateRangeIcon aria-hidden="true" className="size-6" />
                  </button>
                )}

                {/* Separator */}
                <div
                  aria-hidden="true"
                  className="hidden lg:block lg:h-6 lg:w-px lg:bg-gray-900/10"
                />

                {/* Profile dropdown */}
                <Menu as="div" className="relative">
                  <MenuButton className="relative flex items-center">
                    <span className="absolute -inset-1.5" />
                    <span className="sr-only">Open user menu</span>
                    <img
                      alt=""
                      src="/2.png"
                      className="size-8 rounded-full bg-indigo-950 outline outline-1 -outline-offset-1 outline-indigo-950/5"
                    />
                    <span className="hidden lg:flex lg:items-center">
                      <ChevronDownIcon aria-hidden="true" className="ml-2 size-5 text-gray-400" />
                    </span>
                  </MenuButton>
                  <MenuItems
                    transition
                    className="absolute right-0 z-10 mt-2.5 w-32 origin-top-right rounded-md bg-white py-2 shadow-lg outline outline-1 outline-gray-900/5 transition data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                  >
                    {userNavigation.map((item) => (
                      <MenuItem key={item.name}>
                        <a
                          href={item.href}
                          className="block px-3 py-1 text-sm/6 text-gray-900 data-[focus]:bg-gray-50 data-[focus]:outline-none"
                        >
                          {item.name}
                        </a>
                      </MenuItem>
                    ))}
                  </MenuItems>
                </Menu>
              </div>
            </div>
          </div>

          <main className="py-10 bg-gradient-to-b from-blue-50 to-blue-100">
{AI && (
      <div className={`fixed z-50 ${isMobile ? 'inset-0 bg-white overflow-y-auto' : 'bottom-0 right-0 p-4'}`}>
        <AIAssistant AiAssistant={AI} onClose={handleCloseAIAssistant} isMobile={isMobile} />
      </div>
    )}            
                
            <div className="px-4 sm:px-6 lg:px-8">
              <h1 className="text-2xl font-semibold text-gray-900">Documentation</h1>
              <div className="py-4">
                <div id="onboarding"><OnboardingHomeHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="company-info"><CompanyInformationHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="role-calibration"><RoleCalibrationHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="policies"><PoliciesHelp /></div>
                 <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="user-management"><UserManagementHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="members"><MembersHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="staff-costs"><StaffCostsHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="process-creator"><ProcessCreatorHelp /></div>
                <hr className="my-8 border-t-2 border border-gray-300" />
                 <div id="admin-dashboard"><AdminDashboardHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="activity-feed"><ActivityFeedHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="stats"><StatsHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="staff-details"><StaffDetailsHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="reporting"><ReportingHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="appraisal-forms"><AppraisalFormHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="edit-appraisal"><EditAppraisalHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="disciplinary-form"><DisciplinaryFormHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="hr"><HRHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="back-to-work-dashboard"><BackToWorkDashboardHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="back-to-work-form"><BackToWorkFormHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="sickness-ai"><SicknessAIHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="sickness-report"><SicknessReportHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="analytics"><AnalyticsHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="overtime-manager"><OvertimeManagerHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="travel"><TravelHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="clock-in"><ClockInHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="book-shifts"><BookShiftsHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="holiday-chart"><HolidayChartHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="holiday-booking"><HolidayBookHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="meetings"><MeetingsHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="admin-tasks"><CurrentTaskHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="communications"><CommunicationsHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="my-profile"><MyProfileHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="visitor-management"><VisitorsHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="user-sessions"><LoginsHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="ai-assistant"><AIAssistantHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="billing"><BillingHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="staff-online"><OnlineHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="organization-tree"><OrganizationTreeHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="visitor-management"><VisitorsHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="user-sessions"><LoginsHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="ai-assistant"><AIAssistantHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="billing"><BillingHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="task-calendar"><TaskCalendarHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="daily-task-timeline"><TaskCalendarTodayHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="team-task-calendar"><TaskCalendarTeamHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="bottlenecks"><BottlenecksHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="task-training"><TaskTrainingHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="news-feed"><NewsHomeHelp /></div>
                <div className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="customer-crm"><CustomerCrmHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="avenor-guide"><AvenorGuideHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="avenor-docs"><AvenorDocs /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="create-project"><CreateProjectHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="kanban-board"><KanbanHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="brainstorm"><BrainstormHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="project-daily-tasks"><ProjectDailyTasksHelp /></div>

                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="project-meetings"><ProjectMeetingHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="project-chat"><ProjectChatHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="cv-scanner"><PDFScannerHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="interview-meetings"><InterviewMeetingHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="document-builder"><DocumentBuilderHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="quiz-builder"><QuizBuilderHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="training-stats"><TrainingStatsHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
                <div id="knowledge-tree"><KnowledgeTreeHelp /></div>
                <hr className="my-8 border-t-2 border-dashed border-gray-300" />
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  )
}
